<template>
    <div>

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item"  >
                        <p class="control">
                            <span class="button is-static is-medium "  >{{index}}.</span>
                        </p>
                </div>
                <div class="level-item">
                    <h2 class="subtitle has-text-weight-bold"> Parasite name : </h2>
                </div>
                <div class="level-item">
                    <h2 class="subtitle has-text-weight is-italic"> {{data_each_bact.name_bact}} </h2>
                </div>


            </div>
            <div class="level-right">
                <div class="level-item">

                </div>
            </div>
        </nav>


        <nav class="level is-mobile" v-if="data_each_bact.bact_remark">
            <div class="level-left">
                <div class="level-item"  >
                    <h2 class="subtitle has-text-weight"> Remark  </h2>
                </div>
                <div class="level-item"  v-if="data_each_bact.bact_remark">
                    <p class="is-size-4"> <i>{{data_each_bact.bact_remark}}</i> </p>
                </div>


            </div>
        </nav>


        <nav class="level is-mobile" v-if="data_each_bact.lab_method_name">
            <div class="level-left">
                <div class="level-item"  v-if="data_each_bact.lab_method_name">
                    <h2 class="subtitle has-text-weight has-text-info "> Method  </h2>
                </div>
                <div class="level-item"  v-if="data_each_bact.lab_method_name">
                    <h2 class="subtitle has-text-weight"> <i>{{data_each_bact.lab_method_name}}</i>  </h2>
                </div>

                <div class="level-item"  v-if="data_each_bact.lab_method_result_name">
                    <h2 class="subtitle has-text-weight has-text-info "> Value  </h2>
                </div>
                <div class="level-item"  v-if="data_each_bact.lab_method_result_name">
                    <h2 class="subtitle has-text-weight">{{data_each_bact.lab_method_result_name}}</h2>
                </div>

                <div class="level-item" v-if="data_each_bact.remark_method" >
                    <h2 class="subtitle has-text-weight has-text-info"> Remark  </h2>
                </div>
                <div class="level-item"  v-if="data_each_bact.remark_method">
                    <h2 class="subtitle has-text-weight"> <i>{{data_each_bact.remark_method}}</i> </h2>
                </div>


            </div>
        </nav>



<!--        is-fullwidth-->
        <table  class="table is-fullwidth"  v-if="data_each_bact.drugs.length>0"  >
            <tr>
                <th   style="background-color:#f2f4f7"> No. </th>
                <th   style="background-color:#f2f4f7"> Antibiotics </th>
                <th   style="background-color:#f2f4f7"> MIC </th>
                <th   style="background-color:#f2f4f7"> RESULT </th>
                <th   style="background-color:#f2f4f7"> REMARK </th>
                <th   style="background-color:#f2f4f7"> No. </th>
                <th   style="background-color:#f2f4f7"> Antibiotics </th>
                <th   style="background-color:#f2f4f7"> MIC </th>
                <th   style="background-color:#f2f4f7"> RESULT </th>
                <th   style="background-color:#f2f4f7"> REMARK </th>
            </tr>
            <tbody>
<!--    8d9aa8-->
            <tr v-for="drug in drugs_each_bact_rearrage_each2" :key="drug.iddrug_uuid" >
                <template  v-for="(drug_e,index) in drug "  >
                    <td width="1%"  :key="genUUIDLocal(index)"   v-if="drug_e.iddrug !== -1"><p class="is-size-6"  style="color:#8d9aa8;">  {{drug_e.sort_id+1}} </p></td>
                    <td width="1%"  :key="genUUIDLocal(index)"   v-else ></td>
                    <td width="15%" :key="genUUIDLocal(index)"   > <p class="has-text-weight-bold"  style="color:#8d9aa8;"> {{drug_e.drug_name}} </p> </td>
                    <td width="6%"  :key="genUUIDLocal(index)">  <p class="has-text-weight-bold" > {{drug_e.mic_prefix}}{{drug_e.mic_val}} </p>   </td>
                    <td width="4%"  :key="genUUIDLocal(index)"> <p class="has-text-weight-bold  " style="color:#4c5459"> {{drug_e.result_name}} </p> </td>
                    <td width="24%" :key="genUUIDLocal(index)">   <p   class="has-text-grey"  style="color:#4c5459"> {{drug_e.remark}} </p> </td>
                </template>

            </tr>
            </tbody>
        </table>




    </div>
</template>

<script>
    import _ from 'lodash'
    import { genUUID   } from '@/utils.js'
    export default {
        name: "Each_PARA_Show",
        props:{
            data_each_bact : Object,
            index : Number
        },
        computed:{

            drugs_each_bact_rearrage_each2(){
                return _.chunk(Object.values(this.drugs_each_bact_rearrage), 2);
            },
            drugs_each_bact_rearrage: function () {
                const HMR = Math.ceil( this.data_each_bact.drugs.length / 2) // 2 === 2 colunm , HMR === How Many record

                var arr = []
                var ea = 0
                for(var i =0 ;i<HMR ;i++){

                    if(ea === 0){
                        // if(i < this.data_each_bact.drugs.length){
                        //     arr.push(this.data_each_bact.drugs[i])
                        //     // console.log(`ea 0 i< ${JSON.stringify(this.data_each_bact.drugs[i])}`)
                        // }else{
                        //     // console.log(`ea 0 i>=  null`)
                        //     arr.push({
                        //                 "iddrug": -1,
                        //                 "drug_name": "n/a",
                        //                 "idresult": 1,
                        //                 "result_name": "",
                        //                 "idmic_prefix": "",
                        //                 "mic_prefix": "",
                        //                 "mic_val": "",
                        //                 "remark": "",
                        //                 "sort_id": "",
                        //                 "iddrug_uuid": genUUID(10)
                        //             })
                        // }
                        i < this.data_each_bact.drugs.length ?    arr.push(this.data_each_bact.drugs[i])   : arr.push({
                                                                                                                        "iddrug": -1,
                                                                                                                        "drug_name": "",
                                                                                                                        "idresult": 1,
                                                                                                                        "result_name": "",
                                                                                                                        "idmic_prefix": "",
                                                                                                                        "mic_prefix": "",
                                                                                                                        "mic_val": "",
                                                                                                                        "remark": "",
                                                                                                                        "sort_id": "",
                                                                                                                        "iddrug_uuid": genUUID(10)
                                                                                                                    })
                        ea++
                    }
                    if(ea === 1){
                        // if(i+HMR < this.data_each_bact.drugs.length){
                        //
                        //     arr.push(this.data_each_bact.drugs[i+HMR])
                        // }else{
                        //
                        //     arr.push({
                        //         "iddrug": -1,
                        //         "drug_name": "n/a",
                        //         "idresult": 1,
                        //         "result_name": "",
                        //         "idmic_prefix": "",
                        //         "mic_prefix": "",
                        //         "mic_val": "",
                        //         "remark": "",
                        //         "sort_id": "",
                        //         "iddrug_uuid": genUUID(10)
                        //     })
                        // }
                        i+HMR < this.data_each_bact.drugs.length ?  arr.push(this.data_each_bact.drugs[i+HMR])  : arr.push({
                                                                                                                        "iddrug": -1,
                                                                                                                        "drug_name": "",
                                                                                                                        "idresult": 1,
                                                                                                                        "result_name": "",
                                                                                                                        "idmic_prefix": "",
                                                                                                                        "mic_prefix": "",
                                                                                                                        "mic_val": "",
                                                                                                                        "remark": "",
                                                                                                                        "sort_id": "",
                                                                                                                        "iddrug_uuid": genUUID(10)
                                                                                                                    })
                        ea--
                    }

                   // console.log( this.data_each_bact.drugs[i])
                }
                // console.log(data_each_bact.drugs)
                return arr
            }
        },
        methods:{
            genUUIDLocal(_id){
                return `${_id}${genUUID(6)}`
            },
        },
        data(){
            return {
            }

        }
    }
</script>

<style scoped>
    table, th, td {
        border: 2px solid #e8eaed;
    }
</style>